/**
 * Default entity ATIs for Talent/Radar (1P).
 */
import type { TalentEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyTalentEntityATI = readonly TalentEntityATI[];

export const DEFAULT_TALENT_ENTITY_ATI: ReadonlyTalentEntityATI = ['ati:cloud:radar:position'];
